/**
 * Created by work on 17/6/28.
 */
import {REFRESH_LIFE_BANK_TAB, SCROLL_TO_TOP} from '../actions/lifebank';

const initState = {
  lifeBankTab: 0,
  top: false
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_LIFE_BANK_TAB: {
      return Object.assign({}, state, {lifeBankTab: action.newTab});
    }
    case SCROLL_TO_TOP: {
      return Object.assign({}, state, {top: action.newTop});
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/lifeBank.js